import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  SimpleSnackBar,
  TextOnlySnackBar,
} from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { duration } from "moment";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from "../services/auth.service";
import { MyUtils } from "../services/my-utils.service";
import { InfoDialogComponent } from "../shared/dialogs/info-dialog/info-dialog.component";
import { LoaderService } from "./../services/loader.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  tokenSubject: BehaviorSubject<String> = new BehaviorSubject<String>("");
  private dialogRef?: MatDialogRef<InfoDialogComponent>;
  public snackbarRef: MatSnackBarRef<SimpleSnackBar> | undefined;

  constructor(
    public loader: LoaderService,
    public router: Router,
    private authService: AuthService,
    public snackbar: MatSnackBar,
    private myutils: MyUtils
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        (event: any) => {
          if (event instanceof HttpResponse) {
            if (
              !event &&
              !event["body"] &&
              !event["body"]["success"] &&
              !event["body"] &&
              !event["body"]["message"]
            ) {
              // this.loader.hide();

              if (!this.snackbarRef) {
                this.snackbarRef = this.snackbar.open(
                  this.myutils.traslatei18n("messageError"),
                  "",
                  {
                    duration: 3000,
                    panelClass: ["primary-background"],
                  }
                );
                this.snackbarRef.afterDismissed().subscribe(() => (this.snackbarRef = undefined));
              }

              this.loader.stopLoader();
            }

          }
        },
        (error) => {
          
          /** da non togliere */
          console.error(error)
          /** */

          const responseMessage = error["statusText"];

          if (error instanceof HttpErrorResponse) {
            this.loader.stopLoader();
            if (error.status === 401 || error.status === 403) {
              this.login();
              return error;
            } else {
              if (responseMessage !== "OK") {
                if (!this.snackbarRef) {
                  this.snackbarRef = this.snackbar.open(
                    this.myutils.traslatei18n("messageError"),
                    "",
                    {
                      duration: 3000,
                      panelClass: ["colorErrorMessage"],
                    }
                  );
                  this.snackbarRef.afterDismissed().subscribe(() => (this.snackbarRef = undefined));
                }
              }
              return error;
            }
            return error;
          }

        }
      )
    );
  }
  login() {
    // A logout clears the token and resets the shared filter payload. Any request
    // still in flight (or fired by a stale subscription reacting to that reset)
    // comes back 401 and lands here. Resetting again would re-emit the payload,
    // trigger more unauthenticated requests and loop until the UI locks up, so
    // only perform the reset while a session is actually present.
    if (this.authService.tokenSelectValue) {
      this.authService.resetsSubject();
    }

    const target = this.authService.isSSO ? "/logoutsso" : "/login";
    if (this.router.url.split(/[?#]/, 1)[0] === target) {
      return;
    }
    if (this.authService.isSSO) {
      this.router.navigate([target], { queryParams: { logout: true } });
    } else {
      this.router.navigate([target]);
    }
  }
}
